module.exports = __webpack_public_path__ + "static/media/Jeff.782b7d5e.mp4";